// @flow
import parseLatLng from 'mz-utils/parseLatLng'
import type { SuggestionLocation, Location } from '../../../models/location'

/**
 * Conversion from Location to SuggestionLocation
 * @param  {Location} loc
 * @return {SuggestionLocation}
 */
function buildSuggestionFromLocation(loc: Location): SuggestionLocation {
  return {
    display: loc.customName || loc.address,
    place_id: loc.placeId,
    value: loc.address,
    terminal: '',
    type: loc.type,
    name: loc.name,
    ...parseLatLng(loc.lat, loc.lng),
  }
}

export default buildSuggestionFromLocation
